import React from 'react';
import PropTypes from 'prop-types';
import { Text, View } from 'react-native-web';

import { colors } from '../../constants';
import styles from './styles';

// from mobile

const propTypes = {
  label: PropTypes.string.isRequired,
  thresholdReached: PropTypes.bool,
};
const defaultProps = {
  thresholdReached: true,
};

const DottedSeparator = ({ label, thresholdReached }) => {
  const color = !thresholdReached ? colors.no : colors.yes;

  return (
    <View style={styles.separatorContainer}>
      <View style={[styles.dottedLine, { borderColor: color }]} />
      <Text style={[styles.separatorText, { color }]}>{label}</Text>
    </View>
  );
};

DottedSeparator.propTypes = propTypes;
DottedSeparator.defaultProps = defaultProps;

export default DottedSeparator;
